import { io } from "socket.io-client";
import { HOST } from "./constants";

const URL = HOST || "http://localhost:3031";

export const socket = io(URL, {
  transports: ["websocket"],
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 5,
});
